import React, { useRef, useState, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';

import MapManagementContext from '../../MapManagementContext';
import UserSelect from '../../../ReusableComponents/UserSelect/UserSelect';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const FindMemberDialog = ({ open, handleClose, onSubmit, title, legend, agreeText = 'Add', cancelText = 'Cancel' }) => {
  const { user: authUser } = useContext(MapManagementContext);

  const [user, setUser] = useState(null);

  const handleUserChange = useCallback((u) => {
    setUser(u);
  }, []);

  const ref = useRef();

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" ref={ref}>
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent style={{ paddingBottom: '50px' }}>
        <DialogContentText>{legend}</DialogContentText>

        <UserSelect value={user} user={authUser} emailSwitch={true} onChange={handleUserChange} portalRef={ref} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {cancelText}
        </Button>
        <Button onClick={() => onSubmit(user)} color="primary" disabled={!user}>
          {agreeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FindMemberDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  agreeText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default FindMemberDialog;
